export const lightTheme = {
  primary: '#5500B4',
  primaryContrast: '#f9f6f0',

  secondary: '#f9fafb',
  secondaryContrast: '#1E0032',

  background: '#FFFFFF',
  backgroundContrast: '#1E0032',

  lightPurple: '#7878FF',
  lightPurpleContrast: '#f9f6f0',

  text: '#1E0032',

  dealStatusInCreation: '#FAF5FF',
  dealStatusInCreationContrast: '#8200DB',

  dealStatusActive: '#DCFCE7',
  dealStatusActiveContrast: '#016630',

  dealStatusDraft: '#E5E7EB',
  dealStatusDraftContrast: 'black',

  dealStatusError: '#FF7597E5',
  dealStatusErrorContrast: '#F1080C',

  video: '#EFF6FF',
  videoContrast: '#1447E6',

  native: '#DCFCE7',
  nativeContrast: '#016630',

  cWireFormat: '#7878FF',
  cWireFormatContrast: '#FFFFFF',

  banner: '#FAF5FF',
  bannerContrast: '#8200DB',

  success: '#28C88C',
  successContrast: '#FFFFFF',

  error: '#FA4655',
  errorContrast: '#FFFFFF',

  warning: '#F5B432',
  warningContrast: '#FFFFFF',

  info: '#0288D1',
  infoContrast: '#FFFFFF',

  scrollbar: '#BEBEBE',
};
export type ColorTheme = typeof lightTheme;
